/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VolumeMiniReference
 */
export interface VolumeMiniReference {
    /**
     * 
     * @type {number}
     * @memberof VolumeMiniReference
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof VolumeMiniReference
     */
    readonly path?: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeMiniReference
     */
    readonly displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof VolumeMiniReference
     */
    readonly visualTag?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VolumeMiniReference
     */
    readonly type?: VolumeMiniReferenceTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum VolumeMiniReferenceTypeEnum {
    Generic = 'generic',
    GenericMount = 'generic-mount',
    Snfs = 'snfs',
    Btrfs = 'btrfs',
    Lizardfs = 'lizardfs',
    Bcachefs = 'bcachefs',
    Onefs = 'onefs',
    Beegfs = 'beegfs',
    Cloud = 'cloud'
}

export function VolumeMiniReferenceFromJSON(json: any): VolumeMiniReference {
    return VolumeMiniReferenceFromJSONTyped(json, false);
}

export function VolumeMiniReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): VolumeMiniReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'displayName': !exists(json, 'display_name') ? undefined : json['display_name'],
        'visualTag': !exists(json, 'visual_tag') ? undefined : json['visual_tag'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function VolumeMiniReferenceToJSON(value?: VolumeMiniReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


